import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class GravelRoadTileEntity3 extends TileEntity {
	public static readonly frameName = FrameName.GRAVEL_ROAD_3;
}

export default GravelRoadTileEntity3;
